module.exports = __webpack_public_path__ + "static/mia-baker-359838-unsplash-2e943961d5381b71f212d43810908811.jpg";